module.exports = __webpack_public_path__ + "static/media/ok.9f7859a2.png";